$(function() {
    setTimeout(function() {
        var oscarBenefits =  $('.oscar-benefits');
        oscarBenefits.slick({
            dots: false,
            arrows: true,
            focusOnSelect: false,
            infinite: false,
            speed: 500,
            slidesToShow: 4.1,
            slidesToScroll: 1,
            touchThreshold: 5,
            prevArrow: '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
            nextArrow: '<button class="slide-arrow next-arrow"><i class="fa-solid fa-angle-right"></i></button>',
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 3.49,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3.2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.8,
                        arrows: false,
                        speed: 300,
                        easing: 'ease',
                        touchThreshold: 20,
                        touchMove: true,
                        afterChange: function(slick) {
                            if ('ontouchstart' in document && navigator.userAgent.match(/Android/)) {
                                var transitionDuration = $('.oscar-benefits').css('transitionDuration');
                                setTimeout(function() {
                                    $('.oscar-benefits').animate({
                                        scrollLeft: slick.currentSlide * $(slick.$oscarBenefits).width()
                                    }, transitionDuration);
                                }, 200);
                            }
                        }
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.7,
                        arrows: false,
                        speed: 300,
                        easing: 'ease',
                        touchThreshold: 20,
                        touchMove: true,
                        afterChange: function(slick) {
                            if ('ontouchstart' in document && navigator.userAgent.match(/Android/)) {
                                var transitionDuration = $('.oscar-benefits').css('transitionDuration');
                                setTimeout(function() {
                                    $('.oscar-benefits').animate({
                                        scrollLeft: slick.currentSlide * $(slick.$oscarBenefits).width()
                                    }, transitionDuration);
                                }, 200);
                            }
                        }
                    }
                },
            ]
        });
    }, 500);
});
